import {
  Logos,
  ChakraBox as Box,
  ChakraHeading as Heading,
  ChakraButton as Button,
  ChakraFlex as Flex,
} from "@airhelp/react-ui-components";
import Link from "next/link";
import type { SbEditableComponentProps } from "types/storyblok";
import { trackUAClickEvent, trackCustomEvent } from "utils/tracking/utils";
import type { ImageCTAProps } from "../ImageCTA.d";
import { ImageCTAStylesDesktop } from "./ImageCTADesktop.styles";

const renderDivider = (variant: ImageCTAProps["variant"]) =>
  variant === "basic" ? (
    <Box position="absolute" bottom="0" right={{ md: "20%", lg: "30%", xl: "35%" }}>
      <svg width="519" height="517" viewBox="1 0 519 517" fill="none">
        <path
          d="M255.694 1.137L0.786926 1.13696V516.905H518.537L341.75 59.6321C327.689 24.7601 293.378 1.137 255.694 1.137Z"
          fill="#FF6B73"
        />
        <path
          d="M382.569 516.905H0.786987V0.5748L223.957 0.574585C262.204 0.574585 295.951 24.1976 310.013 59.632L448.938 420.164C466.936 466.847 432.627 516.905 382.569 516.905Z"
          fill="#0D3073"
        />
      </svg>
    </Box>
  ) : null;

const ImageCTADesktop = ({
  text,
  buttonText,
  buttonHref = "/404",
  imageUrl,
  gtmSection,
  gtmElement,
  gaLabel,
  gaPlacement,
  variant,
  sbEditable,
}: SbEditableComponentProps<ImageCTAProps>) => {
  const trackingEvents = () =>  {
    trackUAClickEvent(gtmSection, gtmElement);
    trackCustomEvent({ event: "cta_click", label: gaLabel, placement: gaPlacement });
  }

  return (
    <Flex w="full" overflow="auto" position="relative" sx={ImageCTAStylesDesktop[variant].container} {...sbEditable}>
      <Box zIndex="1" sx={ImageCTAStylesDesktop[variant].textContainer}>
        {variant === "ahPlus" && <Logos.AirhelpPlus h={8} w="auto" mb={3} />}
        <Heading color="inherit" {...ImageCTAStylesDesktop[variant].heading}>
          {text}
        </Heading>
        <Link href={buttonHref}>
          <Button
            as={Button}
            onClick={trackingEvents}
            {...ImageCTAStylesDesktop[variant].button}
          >
            {buttonText}
          </Button>
        </Link>
      </Box>
      <Box bgRepeat="no-repeat" bgSize="cover" sx={ImageCTAStylesDesktop[variant].image} bgImage={imageUrl} />
      {renderDivider(variant)}
    </Flex>
  )
};

export default ImageCTADesktop;
